import React from "react";
import { Link } from "gatsby";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { BOOKING_URL, LINK_ATTRIBUTES } from "@/lib/config";

interface NewsArticleLayoutProps {
  title: string;
  date: string;
  author: string;
  children: React.ReactNode;
}

const NewsArticleLayout = ({ title, date, author, children }: NewsArticleLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <section className="bg-gradient-to-br from-primary/10 via-white to-secondary/10 py-16">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <Link to="/news-and-articles" className="text-sm text-primary hover:underline">
                ← Back to News and Articles
              </Link>
              <h1 className="text-4xl md:text-5xl font-bold text-neutral-800 mt-4 mb-4">{title}</h1>
              <div className="flex flex-wrap gap-4 text-sm text-neutral-600">
                <span>{date}</span>
                <span>•</span>
                <span>By {author}</span>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-6">
            <article className="max-w-4xl mx-auto space-y-8 text-neutral-800">
              {children}
            </article>
          </div>
        </section>

        <section className="py-12 bg-neutral-50">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto bg-white border border-primary/10 rounded-3xl p-8 shadow-soft">
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Need personalised advice?</h2>
              <p className="text-neutral-700 mb-6">
                This article is educational only. For personalised advice, assessment, and treatment planning, book a
                consultation with our team in Broadmeadows.
              </p>
              <div className="flex flex-wrap gap-3">
                <Button variant="booking" asChild>
                  <a href={BOOKING_URL} {...LINK_ATTRIBUTES}>
                    Book an Appointment
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </a>
                </Button>
                <Button variant="outline" asChild>
                  <Link to="/contact">Contact Us</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default NewsArticleLayout;
